/**
 * PDP ads ATF — square carousel.
 * Imágenes: autoplay cada 4s (como reviews).
 * Videos (data-menvora-atf-video-mode): avanza al `ended` del clip activo.
 * Sin timer fijo mientras el slide activo sea <video>.
 */
(function () {
  var INTERVAL_MS = 4000;
  var SWIPE_THRESHOLD = 40;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function wantedKeyFromUrl() {
    try {
      var p = new URLSearchParams(window.location.search);
      var raw = (
        p.get('angle') ||
        p.get('angulo') ||
        p.get('ángulo') ||
        p.get('lp') ||
        ''
      )
        .trim()
        .toLowerCase();
      if (
        raw === 'educacion' ||
        raw === 'ritual' ||
        raw === 'educacion-ritual' ||
        raw === 'como-tomar'
      ) {
        return 'hero-educacion';
      }
      if (raw === 'comparativo') return 'hero-comparativo';
    } catch (e) {
      /* ignore */
    }
    return '';
  }

  function resolveInitialIndex(root, slides) {
    var wanted = (root.getAttribute('data-menvora-atf-wanted-key') || '').trim();
    if (!wanted) wanted = wantedKeyFromUrl();

    if (wanted) {
      for (var i = 0; i < slides.length; i++) {
        var key = slides[i].getAttribute('data-menvora-media-key') || '';
        if (key === wanted) return i;
      }
    }

    var fromAttr = parseInt(root.getAttribute('data-menvora-atf-initial-index') || '0', 10);
    if (!isNaN(fromAttr) && fromAttr >= 0 && fromAttr < slides.length) {
      return fromAttr;
    }
    return 0;
  }

  function videoInSlide(slide) {
    if (!slide) return null;
    return slide.querySelector('[data-menvora-atf-video], video.menvora-atf-video');
  }

  function init(root) {
    var viewport = root.querySelector('[data-menvora-atf-viewport]');
    var track = root.querySelector('[data-menvora-atf-track]');
    var dots = root.querySelectorAll('[data-menvora-atf-dot]');
    if (!viewport || !track) return;

    var slides = track.querySelectorAll('.menvora-ads-atf-carousel__slide');
    var count = slides.length;
    if (count < 1) return;

    var videoMode = root.getAttribute('data-menvora-atf-video-mode') === '1';
    var index = resolveInitialIndex(root, slides);
    var timer = null;
    var reduced = prefersReducedMotion();
    var dragging = false;
    var startX = 0;
    var baseTranslate = 0;
    var endedBound = false;
    var userPaused = false;
    var tapToggleGuard = false;

    function slideStep() {
      if (!slides[0]) return 0;
      return slides[0].offsetWidth;
    }

    function translateForIndex(i) {
      return -i * slideStep();
    }

    function stopTimer() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function pauseAllVideos() {
      for (var i = 0; i < slides.length; i++) {
        var v = videoInSlide(slides[i]);
        if (!v) continue;
        try {
          v.pause();
        } catch (e) {
          /* ignore */
        }
      }
    }

    function onActiveVideoEnded() {
      next();
    }

    function playActiveVideo(opts) {
      opts = opts || {};
      if (userPaused && !opts.force) return false;

      pauseAllVideos();
      var slide = slides[index];
      var video = videoInSlide(slide);
      if (!video) return false;

      if (!endedBound) {
        root.addEventListener(
          'ended',
          function (ev) {
            if (!ev.target || !ev.target.hasAttribute('data-menvora-atf-video')) return;
            if (!slides[index] || !slides[index].contains(ev.target)) return;
            userPaused = false;
            onActiveVideoEnded();
          },
          true
        );
        endedBound = true;
      }

      if (opts.reset !== false) {
        try {
          video.currentTime = 0;
        } catch (e) {
          /* ignore */
        }
      }
      video.muted = true;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          /* Autoplay bloqueado: swipe/dot/tap siguen OK */
        });
      }
      return true;
    }

    function toggleActiveVideo() {
      var video = videoInSlide(slides[index]);
      if (!video) return;
      if (video.paused) {
        userPaused = false;
        video.muted = true;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else {
        userPaused = true;
        video.pause();
      }
    }

    function scheduleAdvance() {
      stopTimer();
      if (reduced) return;

      /* Video activo: play; al ended → next. Imagen: timer solo si hay ≥2. */
      if (videoInSlide(slides[index])) {
        if (!userPaused) playActiveVideo({ reset: false, force: false });
        return;
      }

      if (count < 2) return;
      timer = window.setInterval(next, INTERVAL_MS);
    }

    function setIndex(nextIndex, animate) {
      index = (nextIndex + count) % count;
      userPaused = false;
      track.classList.toggle('is-instant', animate === false);
      track.style.transform = 'translate3d(' + translateForIndex(index) + 'px, 0, 0)';

      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === index);
      }
      for (var d = 0; d < dots.length; d++) {
        var active = d === index;
        dots[d].classList.toggle('is-active', active);
        dots[d].setAttribute('aria-current', active ? 'true' : 'false');
      }
      track.setAttribute('aria-label', 'Creativo ' + (index + 1) + ' de ' + count);

      /* Cambio de slide: reinicia el video del nuevo índice */
      stopTimer();
      if (videoInSlide(slides[index])) {
        playActiveVideo({ reset: true, force: true });
      } else {
        scheduleAdvance();
      }
    }

    function next() {
      setIndex(index + 1, true);
    }

    function prev() {
      setIndex(index - 1, true);
    }

    for (var di = 0; di < dots.length; di++) {
      (function (dotIndex) {
        dots[dotIndex].addEventListener('click', function () {
          setIndex(dotIndex, true);
        });
      })(di);
    }

    root.querySelectorAll('modal-opener .product__media-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        stopTimer();
        pauseAllVideos();
      });
    });

    viewport.addEventListener(
      'touchstart',
      function (ev) {
        if (!ev.changedTouches || !ev.changedTouches[0]) return;
        dragging = true;
        startX = ev.changedTouches[0].clientX;
        baseTranslate = translateForIndex(index);
        track.classList.add('is-dragging');
        stopTimer();
        /* No pausar video aquí: el tap debe poder play/pause */
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchmove',
      function (ev) {
        if (!dragging || !ev.changedTouches || !ev.changedTouches[0]) return;
        var deltaX = ev.changedTouches[0].clientX - startX;
        track.style.transform = 'translate3d(' + (baseTranslate + deltaX) + 'px, 0, 0)';
      },
      { passive: true }
    );

    function endDrag(clientX) {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      var diff = clientX - startX;
      if (Math.abs(diff) >= SWIPE_THRESHOLD) {
        setIndex(index, false);
        window.requestAnimationFrame(function () {
          if (diff < 0) next();
          else prev();
        });
      } else {
        /* Tap: snap sin reiniciar; el click del video hace play/pause */
        track.style.transform = 'translate3d(' + translateForIndex(index) + 'px, 0, 0)';
        if (!videoInSlide(slides[index])) {
          scheduleAdvance();
        }
      }
    }

    root.querySelectorAll('[data-menvora-atf-video]').forEach(function (videoEl) {
      videoEl.style.cursor = 'pointer';
      videoEl.setAttribute('tabindex', '0');
      videoEl.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (!slides[index] || !slides[index].contains(videoEl)) return;
        toggleActiveVideo();
        tapToggleGuard = true;
        window.setTimeout(function () {
          tapToggleGuard = false;
        }, 400);
      });
      videoEl.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Enter' && ev.key !== ' ') return;
        ev.preventDefault();
        if (!slides[index] || !slides[index].contains(videoEl)) return;
        toggleActiveVideo();
      });
    });

    viewport.addEventListener(
      'touchend',
      function (ev) {
        if (!ev.changedTouches || !ev.changedTouches[0]) return;
        endDrag(ev.changedTouches[0].clientX);
      },
      { passive: true }
    );
    viewport.addEventListener(
      'touchcancel',
      function () {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        setIndex(index, true);
      },
      { passive: true }
    );

    /* En modo video no pausar por hover (rompe el ended → next) */
    if (!videoMode) {
      viewport.addEventListener('mouseenter', stopTimer);
      viewport.addEventListener('mouseleave', scheduleAdvance);
    }

    window.addEventListener('resize', function () {
      setIndex(index, false);
    });

    if (typeof IntersectionObserver === 'function') {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              stopTimer();
              pauseAllVideos();
            } else {
              scheduleAdvance();
            }
          });
        },
        { threshold: 0.35 }
      );
      io.observe(root);
    }

    setIndex(index, false);
  }

  function boot() {
    document.querySelectorAll('[data-menvora-atf-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
